/**
 * Publishes what the header's Refresh button can actually do.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Headless. The header is a SIBLING of the tab tree, so it cannot read the live
 * preview or the Standard draft contexts — this sits inside them and hands the
 * two callables up through the drawer's footer context, the same way the
 * Standard tab already registers its footer actions.
 *
 * The weights preview is not a react-query entry (it is hand-rolled state), so
 * `refetch` is the ONLY way in; there is no key to invalidate.
 */

import { useEffect, type FC } from 'react';

import { useOptionalFlowOptimizerLivePreview } from '../context/FlowOptimizerLivePreviewContext';
import { useOptionalFlowOptimizerDrawerFooter } from '../FlowOptimizerDrawerFooterContext';
import { useOptionalStandardDraftContext } from '../standard-draft';

/** Mounted inside the providers; renders nothing. */
export const RefreshCapabilityRegistrar: FC = () => {
  // Optional: this is headless chrome, so a tab tree mounted without the
  // drawer shell (as specs do) must keep working rather than throw.
  const setRefreshSlot = useOptionalFlowOptimizerDrawerFooter()?.setRefreshSlot;
  const preview = useOptionalFlowOptimizerLivePreview();
  const standard = useOptionalStandardDraftContext();

  const refetchWeights = preview?.live.refetch;
  const refetchFlow = standard?.flowQuery.refetch;
  const flowDirty = Boolean(standard?.draftState.dirty);

  useEffect(() => {
    if (!setRefreshSlot) return;
    setRefreshSlot({ refetchWeights, refetchFlow, flowDirty });
    return () => setRefreshSlot(null);
  }, [setRefreshSlot, refetchWeights, refetchFlow, flowDirty]);

  return null;
};

export default RefreshCapabilityRegistrar;
